<!--<template>-->
<!--	<li :class="{ 'has-unread-messages' : notification.broadcasted }" @mouseover="$emit('seen')">-->
<!--        <router-link :to="notification.data.url">-->
<!--            <div class="v-contact-avatar">-->
<!--                <img v-bind:src="notification.data.avatar" v-bind:alt="notification.data.name" />-->
<!--            </div>-->

<!--            <div class="v-contact">-->
<!--                <p>-->
<!--                    {{ notification.data.body }}-->
<!--                    - <small>{{ date }}</small>-->
<!--                </p>-->
<!--            </div>-->
<!--        </router-link>-->
<!--	</li>-->
<!--</template>-->
<template>
    <a @click.prevent="detailNoty(notification.data.url)" class="noty-content">
        <div class="noty-avatar">
            <img v-bind:src="notification.data.avatar" v-bind:alt="notification.data.name"/>
        </div>
        <div class="noty-contact" :class="{'read-at': !notification.read_at}">
            {{ notification.data.body }}
            <br>
            <small>{{ date }}</small>
        </div>
    </a>
</template>
<script>
    import Helpers from '../mixins/Helpers';

    export default {
        props: ['notification'],

        mixins: [Helpers],

        computed: {
            date() {
                if (this.isItToday(this.notification.created_at)) {
                    return this.parseDateForToday(this.notification.created_at);
                }

                return this.parseDate(this.notification.created_at);
            }
        },
        methods: {
            detailNoty(url) {

                if (!this.notification.read_at) {
                    axios.patch('/notification-read/' + this.notification.id)
                        .then(response => {
                            for (let i in Store.state.notifications) {
                                if (Store.state.notifications[i].id == this.notification.id) {
                                    Store.state.notifications[i].read_at = true
                                }
                            }
                        });
                }
                Store.modals.notifications.show = false;
                this.$router.push(url)
            }
        }
    };
</script>

<style scoped>
    .noty-content {
        display: flex;
        align-items: center;
        justify-content: start;
        color: #5c5c5c;
    }

    .noty-content:hover {
        color: #020000;
    }

    .noty-avatar {
        width: 30px;
    }

    .noty-contact {
        padding: 10px;
        width: 100%;
        margin: 3px;
    }

    .read-at {
        background: #cbe8ff;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Notification.vue